import { BrandRegisterPayload, LogoDescribeResponse } from "@/store/brands/types";
import { BrandSuggestion } from "../types";
import { getDomainFromUrl } from "@/utils/url/getDomainFromUrl";
import { call, put } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import { setBrand, setBrandRegisterSuccess } from "../slice";
import { applySagaError } from "@/store/utils/saga";
import { fetchBrandRegister } from "@/api/fetchBrandRegister";
import { fetchDescribeBrandByDomain } from "@/api/fetchDescribeBrand";



export function* fetchBrandRegisterSaga(action: PayloadAction<BrandRegisterPayload>) {
    try {
      const brand: BrandRegisterPayload = action.payload;
      const suggestion: BrandSuggestion | null = yield call(fetchBrandRegister, brand);
      let describe: LogoDescribeResponse | null = null;

      if (brand.website) {
        describe = yield call(fetchDescribeBrandByDomain, brand.website);
      }

      const name = suggestion?.name ?? brand.name;
      const website = brand.website ?? (suggestion?.website ? getDomainFromUrl(suggestion?.website) : undefined);
      const description = describe?.description ?? suggestion?.description;
      const logoUrl = brand.logoUrl;
      const region = suggestion?.region || 'Global';
      const brandType = suggestion?.brand_type || undefined;
      const industry = suggestion?.industry || undefined;
      const primaryLanguage = suggestion?.primary_language || 'English';

      yield put(setBrand({  
        name,
        website,
        description,
        region,
        brandType,
        industry,
        primaryLanguage,
        ...(logoUrl && { logoUrl }),
      }));
    } catch (error) {
      yield* applySagaError(error, {
        operationName: "auth.fetchBrandRegister",
        sentryContext: {
          brand_name: action.payload?.name,
        },
        notifyUser: false,
      });
    } finally {
      yield put(setBrandRegisterSuccess());
    }
  }
  